export default {
  submit: 'Submit',
  save: 'Save',
  'submit.ok': 'Submit successfully',
  'save.ok': 'Saved successfully',
  'operation.success': 'Operation successful',
  'confirm-submit': 'Confirm submit',
  search: 'Search',
  'switch-trading-accounts': 'Switch trading accounts',
  'margin-free': 'Margin Free',
  credit: 'Credit',
  mttype: 'platform',
  leverage: 'Leverage',
  buy: 'Buy',
  sell: 'Sell',
  'market-order': 'Market Order',
  'limit-order': 'Limit Order',
  'buy-long': 'Buy / Long',
  'sell-short': 'Sell / Short',
  'personal-zone': 'Personal Zone',
  'account-settings': 'Account Settings',
  'ib-zone': 'IB Zone',
  logout: 'Logout',
  'close-a-position': 'Close a Position',
  'confirm-close-{ticket}': 'Confirm Close #{ticket}',

  // no account tip
  'no-account-tip': 'No account',
  'need-open-account': 'No trading account found. Please create one first.',
}
